<template>
  <div class="address_page_container">
    <!-- 统一导航栏组件，使用 content 插槽 -->
    <title-bar-back :showBack="true" @back="back">
      <template #content>
        <!-- 搜索模式 -->
        <div v-if="isSelect" class="search_wrapper">
          <div class="search_box">
            <img
              src="@/assets/common/icon_search_search@2x.png"
              class="search_icon"
              alt="搜索"
            />
            <input
              v-model="searchKey"
              type="text"
              placeholder="收件人/手机号"
              class="search_input"
              @input="onSearchInput"
              @keyup.enter="onSearch"
            />
          </div>
          <div class="cancel_btn" @click="onCancelSearch">取消</div>
        </div>
        <!-- 切换模式 -->
        <div v-else class="tab_wrapper">
          <div class="switch_container">
            <div
              :class="[
                'switch_item',
                activeType === 1 ? 'switch_item_active' : 'switch_item_normal'
              ]"
              @click="onSwitchType(1)"
            >
              店铺地址
            </div>
            <div
              :class="[
                'switch_item',
                activeType === 3 ? 'switch_item_active' : 'switch_item_normal'
              ]"
              @click="onSwitchType(3)"
            >
              客户地址
            </div>
          </div>
        </div>
      </template>
    </title-bar-back>

    <div class="main_content">
      <!-- 无数据 -->
      <none-list
        v-if="!getUserAddressList.rows || getUserAddressList.rows.length === 0"
      />

      <!-- 有数据 -->
      <van-list
        v-else
        v-model="loading"
        :finished="!getUserAddressList.hasNextPage"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="address_lists">
          <address-item
            v-for="(item, index) in getUserAddressList.rows"
            :key="index"
            :rows="item"
            :rowIndex="index"
            @editAddress="editAddress"
            @clickAddressItem="clickAddressItem"
          />
        </div>
      </van-list>
    </div>

    <!-- 底部按钮 -->
    <add-btn @addAddress="addAddress" />
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import NoneList from "./components/NoneList";
import AddBtn from "./components/AddBtn";
import AddressItem from "./components/AddressItem";
import { List } from "vant";

export default {
  name: "AddressList",
  components: {
    TitleBarBack,
    NoneList,
    AddBtn,
    AddressItem,
    [List.name]: List
  },
  data() {
    return {
      loading: false,
      searchKey: "",
      activeType: 1, // 1: 店铺地址, 3: 客户地址
      deliveryMode: null,
      isSelect: false,
      timer: null // 用于搜索防抖
    };
  },
  computed: {
    getUserAddressList() {
      return (
        this.$store.getters.getUserAddressList || {
          rows: [],
          hasNextPage: false
        }
      );
    }
  },
  created() {
    // 从路由 query 参数中读取初始化数据
    if (this.$route.query.type) {
      const type = parseInt(this.$route.query.type);
      if ([1, 3].includes(type)) {
        this.activeType = type;
      }
    }
    if (this.$route.query.deliveryMode !== undefined) {
      this.deliveryMode = parseInt(this.$route.query.deliveryMode);
    }
    const previousPage = this.$route.query.previousPage;
    this.isSelect = previousPage && previousPage !== "personalcenter";

    this.getData(1);
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    // 获取地址列表
    getData(pageIndex = 1) {
      this.loading = true;
      const params = {
        pageNo: pageIndex,
        pageSize: 20,
        type: this.activeType,
        keywords: this.searchKey
      };
      if (this.deliveryMode !== null && this.deliveryMode !== undefined) {
        params.deliveryMode = this.deliveryMode;
      }
      this.$store
        .dispatch("mine/getUserAddress", { params })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onLoad() {
      if (
        this.getUserAddressList.hasNextPage &&
        (!this.getUserAddressList.pageCount ||
          this.getUserAddressList.pageNo < this.getUserAddressList.pageCount) &&
        !this.loading
      ) {
        const pageIndex = this.getUserAddressList.pageNo + 1;
        this.getData(pageIndex);
      } else {
        this.loading = false;
      }
    },
    // 输入框输入事件：带防抖
    onSearchInput() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.getData(1);
      }, 500);
    },
    // 确认检索
    onSearch() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.getData(1);
    },
    // 点击取消：清空并重新检索
    onCancelSearch() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.searchKey = "";
      this.getData(1);
    },
    // 切换地址类型 (店铺/客户)
    onSwitchType(type) {
      if (this.activeType !== type) {
        this.activeType = type;
        this.searchKey = "";
        this.getData(1);
      }
    },
    // 新增收货地址
    addAddress() {
      this.$router.push({
        path: "/mine/addeditaddress",
        query: {
          ...this.$route.query,
          key: "新增收货人",
          type: this.activeType
        }
      });
    },
    // 编辑收货地址
    editAddress(id, rowIndex) {
      this.$router.push({
        path: "/mine/addeditaddress",
        query: {
          ...this.$route.query,
          key: "编辑收货人",
          id: id,
          rowIndex: rowIndex,
          type: this.activeType
        }
      });
    },
    // 点击收货地址项
    clickAddressItem(items) {
      if (this.isSelect) {
        if (this.$route.query.previousPage === "pur") {
          localStorage.setItem("pur-address", JSON.stringify(items));
          this.$router.back(-1);
          return;
        }
        if (this.$route.query.previousPage === "exchangeMilkPur") {
          localStorage.setItem(
            "exchange-milk-pur-address",
            JSON.stringify(items)
          );
          this.$router.back(-1);
          return;
        }
        if (this.$route.query.previousPage === "milkPlan") {
          if (this.$route.query.switchPur === "one") {
            localStorage.setItem(
              "exchange-milk-plan-one-address",
              JSON.stringify(items)
            );
            localStorage.setItem(
              "exchange-milk-plan-one-parcelId",
              this.$route.query.parcelId
            );
          } else {
            localStorage.setItem(
              "exchange-milk-plan-all-address",
              JSON.stringify(items)
            );
          }
          this.$router.back(-1);
          return;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.address_page_container {
  min-height: 100vh;
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  /* 搜索框模式 */
  .search_wrapper {
    flex: 1;
    display: flex;
    align-items: center;
    margin-left: 8px;

    .search_box {
      flex: 1;
      height: 32px;
      background-color: #f2f2f2;
      border-radius: 17px;
      display: flex;
      align-items: center;
      padding: 0 12px;
      box-sizing: border-box;

      .search_icon {
        width: 22px;
        height: 22px;
        margin-right: 6px;
      }

      .search_input {
        flex: 1;
        border: none;
        background: transparent;
        font-size: 12px;
        color: #222222;
        padding: 0;
        margin: 0;
        height: 100%;
        &::placeholder {
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }

    .cancel_btn {
      font-size: 12px;
      color: #222222;
      margin-left: 12px;
      cursor: pointer;
      white-space: nowrap;
    }
  }

  /* 选项卡模式 */
  .tab_wrapper {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    margin-left: 40px;

    .switch_container {
      width: 200px;
      height: 38px;
      border-radius: 50px;
      border: 0.5px solid rgba(0, 0, 0, 0.06);
      display: flex;
      padding: 4px;
      box-sizing: border-box;
      background-color: #ffffff;

      .switch_item {
        height: 100%;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
      }

      .switch_item_active {
        color: #ffffff;
        background-color: #bf9264; // H5项目原有的金色/品牌色
      }

      .switch_item_normal {
        color: rgba(0, 0, 0, 0.45);
        background-color: #ffffff;
      }
    }
  }

  .main_content {
    flex: 1;
    padding-bottom: 80px;
  }

  .address_lists {
    background: transparent;
    padding-bottom: 20px;
  }
}
</style>
